module.exports = __webpack_public_path__ + "img/img (26).eac8236c.jpg";